import type { FeatureListSection } from "@/types/content";

interface Props {
  section: FeatureListSection;
}

export default function FeatureListSectionBlock({ section }: Props) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-slate-50">
      <div className="max-w-5xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10">
            {section.title}
          </h2>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.features.map((feature) => (
            <div
              key={feature._key}
              className="bg-white rounded-xl p-6 border border-slate-100"
            >
              {feature.icon && (
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-4">
                  <i className={`${feature.icon} text-lg`} />
                </div>
              )}
              <h3 className="text-lg font-semibold text-slate-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}